/* eslint-disable no-console */
import React, { Fragment, useEffect, useState } from 'react';
import { useStyles } from './skills.style';
import { CommonButtonTypes } from 'Common/Types/Types';
import twoColorBG from 'Assets/img/svg/Backgrounds/twoColorBg.svg';

// redux imports
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'ReduxStore/store';
import { GetAllResources, GetResourceById } from 'ReduxStore/resources/Action';
import { CustomSearchBox } from './AutoComplete';
import { checkImage, goToLink, setImage } from 'Helpers';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Pagination from '@material-ui/lab/Pagination';
import ClipLoader from 'react-spinners/ClipLoader';
import Header from 'Components/Header/Header';
interface SkillsProps extends CommonButtonTypes {
	width?: string;
}
const Skills = ({ common }: SkillsProps) => {
	const classes = useStyles({ common });
	const [selectedResource, setSelectedResource] = useState('');
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const matches = useMediaQuery('(max-width:440px)');
	const ipadSize = useMediaQuery('(max-width:1024px)');
	const itemsPerPage = 6;
	const [page, setPage] = useState(1);
	let removed;
	const handleSelectedChange = async (id: string) => {
		// const removed = [];
		console.log('I am clicked now ---> ');
		setLoading(true);
		removed = [];

		console.log(loading);
		// window.location.reload();
		await dispatch(GetResourceById(id));
		setPage(1);
		window.scrollTo(0, 0);
		console.log(' i am  done');
	};
	useEffect(() => {
		setLoading(!loading);
		dispatch(GetAllResources());
		const id = selectedResource ? selectedResource : '1';
		dispatch(GetResourceById(id));
		setPage(1);
		setLoading(!loading);
	}, []);
	const resources: any[] = useSelector((state: RootState) => state.resources['welcome']);
	const resourcesByCategory: any[] = useSelector((state: RootState) => state.resources['resourceItem']);
	removed = resourcesByCategory?.slice((page - 1) * itemsPerPage, page * itemsPerPage);

	// eslint-disable-next-line no-console
	console.log('object', removed);
	return (
		<Fragment>
			<Header />
			<div style={{ backgroundImage: `url(${twoColorBG})`, height: '100px' }}>
				<section className="d-flex flex-column align-items-end flex-wrap">
					<div className={classes.search}>
						<CustomSearchBox
							itemList={resources}
							onClick={handleSelectedChange}
							setSelected={setSelectedResource}
							defaultValue="Search"
							label="Search"
						/>
					</div>
					<ul className={`${classes.listItem} my-2`}>
						{resourcesByCategory ? (
							removed.map(resource => (
								<li key={resource.id}>
									<div
										className={`d-flex flex-row align-items-center border-bottom ${
											ipadSize ? 'flex-wrap' : 'flex-nowrap'
										}`}
									>
										<img
											src={resource.imageName && setImage(resource.imageName)}
											alt=""
											className={classes.image}
										/>
										<div className="d-flex flex-column">
											<a
												className={classes.links}
												href={resource.externalLink}
												target="_blank"
												rel="noopener noreferrer"
											>
												<h4>{resource.title}</h4>
											</a>
											<h6 className="text-secondary"> {goToLink(resource.description, 100).newText}</h6>
											<span>
												{goToLink(resource.description, 100)?.read && (
													<a
														className={classes.links}
														href={resource.externalLink}
														target="_blank"
														rel="noopener noreferrer"
													>
														{goToLink(resource.description, 100)?.read}
													</a>
												)}
											</span>
										</div>
									</div>
								</li>
							))
						) : (
							<div className={classes.loading}>
								<h4>Wait a moment...</h4>
								<ClipLoader color={'#67AEB3'} loading={true} size={40} />
							</div>
						)}
					</ul>

					{resourcesByCategory && resourcesByCategory.length > 0 && (
						<Pagination
							count={Math.ceil(resourcesByCategory?.length / itemsPerPage)}
							color="primary"
							className={classes.pagination}
							page={page}
							onChange={(event, val) => setPage(val)}
						/>
					)}
				</section>
			</div>
		</Fragment>
	);
};

export default Skills;
